import * as Sentry from '@sentry/gatsby';
import LANGUAGES from '../../languages';

export const URLS = {
    'APPLE_APP_STORE_AIDA_MOBILE': 'https://s.tclab.it/ios-aida-mobile',
    'APP_GALLERY_AIDA': 'https://s.tclab.it/xag-aida',
    'AIDA_LINK_WINDOWS': 'https://s.tclab.it/aida-link-windows',
    'AIDA_LINK_LINUX': 'https://s.tclab.it/aida-link-linux',
    'FACEBOOK': 'https://s.tclab.it/facebook',
    'INSTAGRAM': 'https://s.tclab.it/instagram',
    'TWITTER': 'https://s.tclab.it/twitter',
    'LINKEDIN': 'https://s.tclab.it/linkedin',
    'YOUTUBE': 'https://s.tclab.it/youtube'
};

export const getCurrentLocale = location => {
    const a = location.split('/');
    if (!!a) {
        const lang = a[ 1 ];
        if (LANGUAGES.langs.indexOf(lang) >= 0) {
            return lang;
        }
        else {
            return 'en';
        }
    }
    else {
        return 'en';
    }
};

export const getDocumentationUrl = (location = '') => {
    return `https://doc.aidacloud.com/${getCurrentLocale(location)}/aida`;
};

export const getLocalizedUrl = (path, location = '') => {
    return '/' + getCurrentLocale(location) + path;
};

export const report_app_store_click = label => {
    console.log('Reporting app_store_click to', label);
    registerGoogleEvent('external_app_store_click', label, 0);
};

export const report_plan_click = (plan, language) => {
    console.log('Plan report', plan, language);
    const value = plan === 'professional' ? 5.99 : 24.49;
    if (language === 'it') {
        // Click periodo gratuito (it) conversion page
        registerGoogleEvent('plan_click', plan, value);
    }
    else {
        // Click periodo gratuito (en) conversion page
        registerGoogleEvent('plan_click', plan, value);
    }
};

export const LAMBDA_FORM_HANDLER = (() => {
    if (process.env.NODE_ENV === 'production') {
        // prod
        return 'https://6rmvtaot6c.execute-api.eu-central-1.amazonaws.com';
    }
    else if (window.location.href.indexOf('dev.aidacloud.com') >= 0) {
        // test
        return 'https://fbcjfw3s1a.execute-api.eu-central-1.amazonaws.com';
    }
    else {
        // dev
        return 'https://vi26az98q7.execute-api.eu-central-1.amazonaws.com';
    }
})();

export const RECAPTCHA_SITE_KEY = (() => {
    if (process.env.NODE_ENV === 'production') {
        // Prod
        return '6LctgpMUAAAAAOwwxMlA-DBShAkvTqatWd2H9pWH';
    }
    else {
        // dev/local dev (skip): https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
        return '6LdXP5MUAAAAANE7HdR_BO-EB_J8d9b9wIAGTEgl';
    }
})();

export const registerLinkedinConversion = (conversionId = 7653001) => {
    if (window.lintrk && typeof window.lintrk === 'function') {
        window.lintrk('track', { conversion_id: conversionId });
    }
};

export const registerCapterra = () => {
    if (window.capterraTrackingListener && typeof window.capterraTrackingListener === 'function') {
        window.capterraTrackingListener();
    }
};

export const registerActiveCampaign = (type, email) => {
    if (window.sendActiveCampaignEvent && typeof window.sendActiveCampaignEvent === 'function') {
        window.sendActiveCampaignEvent(type, email);
    }
};

export const registerFormConversion = function (value = 1) {
    console.log('registerFormConversion', JSON.stringify(arguments, null, 2)); // Good for local debug
    Sentry.captureMessage(`Attempting registerFormConversion for value: ${value}`); // Changed message slightly for clarity

    if (window.gtag && typeof window.gtag === 'function') {
        // Log that gtag *was* found
        Sentry.captureMessage(`gtag function FOUND. Sending conversion. Value: ${value}, SendTo: AW-11295403306/hd-4COvUj-YZEKraiIoq`);
        try {
            window.gtag('event', 'conversion', {
                'send_to': 'AW-11295403306/hd-4COvUj-YZEKraiIoq',
                'value': value,
                'currency': 'EUR'
            });
            // Optional: Log success *after* call - Note: gtag is async, this only means the call was made, not that Google processed it.
            // Sentry.captureMessage(`gtag conversion call executed for value: ${value}`);
        }
        catch (error) {
            // Catch any immediate synchronous errors (less common for gtag)
            Sentry.captureException(error, {
                extra: {
                    message: `Error during gtag conversion call for value ${value}`,
                    conversionId: 'AW-11295403306/hd-4COvUj-YZEKraiIoq',
                    value: value,
                    currency: 'EUR'
                }
            });
        }
    }
    else {
        // Log that gtag was NOT found - This is critical!
        const gtagType = typeof window.gtag;
        const gtagValue = window.gtag ? window.gtag.toString().substring(0, 100) : 'undefined'; // Get type and maybe part of value if not undefined
        const message = `gtag function NOT FOUND when attempting conversion. Value: ${value}. typeof window.gtag: ${gtagType}. window.gtag value: ${gtagValue}`;
        console.warn(message);
        Sentry.captureMessage(message, 'warning');
    }
};

export const registerScrollDepthConversion = function (value = 1) {
    if (window.gtag && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
            'send_to': 'AW-11295403306/C2psCOen1KIaEKraiIoq',
            'value': value,
            'currency': 'EUR'
        });
    }
};

export const registerFormInteractionConversion = function (value = 1) {
    if (window.gtag && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
            'send_to': 'AW-11295403306/FIb5CMDU1KIaEKraiIoq',
            'value': value,
            'currency': 'EUR'
        });
    }
};

export const registerButtonClickConversion = function (value = 1) {
    if (window.gtag && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
            'send_to': 'AW-11295403306/LtgNCIjA56IaEKraiIoq',
            'value': value,
            'currency': 'EUR'
        });
    }
};

export const registerGoogleEvent = function (event, payload = '', value = 0) {
    console.log('registerGoogleEvent', arguments);
    if (window.gtag && typeof window.gtag === 'function') {
        console.log(`Sending google event now: event ${event} payload ${payload} value ${value}`);
        /*window.dataLayer.push({
            'event': event,
            'payload': payload,
            'value': value
        });*/
        window.gtag('event', event, {
            value
        });
    }
    else {
        console.warn('gtag not found for registerGoogleEvent');
    }
};

export const registerFacebookEvent = function (event, value = 0) {
    console.log('registerFacebookEvent', arguments);
    if (window.fbq && typeof window.fbq === 'function') {
        if (value > 0) {
            window.fbq('track', event, { currency: 'EUR', value: value });
        }
        else {
            window.fbq('track', event);
        }
    }
};

/* eslint-disable */
export const initializeAndTrack = enabled => {
    if (enabled) {
        // TODO
    }
};

export const getGaCrossDomainParameters = () => {

};

export const getSupportedImageFormat = () => {
    const avif = new Image();
    avif.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
    const webp = new Image();
    webp.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';

    return avif.height === 1 ? 'avif' : webp.height === 1 ? 'webp' : 'png';
};

export function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
}

export function startCase(str) {
    if (!str) return str;  // Return the original string if it's empty or undefined
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getCountries = () => {
    return [
        { value: 'FR', displayValue: 'France' },
        { value: 'DE', displayValue: 'Germany' },
        { value: 'IT', displayValue: 'Italy' },
        { value: 'ES', displayValue: 'Spain' },
        { value: 'PT', displayValue: 'Portugal' },
        { value: 'US', displayValue: 'United States' },
        { value: 'GB', displayValue: 'United Kingdom' },
        { value: 'xxx', displayValue: '---------', disabled: true },
        { value: 'AF', displayValue: 'Afghanistan' },
        { value: 'AX', displayValue: 'Åland Islands' },
        { value: 'AL', displayValue: 'Albania' },
        { value: 'DZ', displayValue: 'Algeria' },
        { value: 'AS', displayValue: 'American Samoa' },
        { value: 'AD', displayValue: 'Andorra' },
        { value: 'AO', displayValue: 'Angola' },
        { value: 'AI', displayValue: 'Anguilla' },
        { value: 'AQ', displayValue: 'Antarctica' },
        { value: 'AG', displayValue: 'Antigua and Barbuda' },
        { value: 'AR', displayValue: 'Argentina' },
        { value: 'AM', displayValue: 'Armenia' },
        { value: 'AW', displayValue: 'Aruba' },
        { value: 'AU', displayValue: 'Australia' },
        { value: 'AT', displayValue: 'Austria' },
        { value: 'AZ', displayValue: 'Azerbaijan' },
        { value: 'BS', displayValue: 'Bahamas' },
        { value: 'BH', displayValue: 'Bahrain' },
        { value: 'BD', displayValue: 'Bangladesh' },
        { value: 'BB', displayValue: 'Barbados' },
        { value: 'BY', displayValue: 'Belarus' },
        { value: 'BE', displayValue: 'Belgium' },
        { value: 'BZ', displayValue: 'Belize' },
        { value: 'BJ', displayValue: 'Benin' },
        { value: 'BM', displayValue: 'Bermuda' },
        { value: 'BT', displayValue: 'Bhutan' },
        { value: 'BO', displayValue: 'Bolivia, Plurinational State of' },
        { value: 'BQ', displayValue: 'Bonaire, Sint Eustatius and Saba' },
        { value: 'BA', displayValue: 'Bosnia and Herzegovina' },
        { value: 'BW', displayValue: 'Botswana' },
        { value: 'BV', displayValue: 'Bouvet Island' },
        { value: 'BR', displayValue: 'Brazil' },
        { value: 'IO', displayValue: 'British Indian Ocean Territory' },
        { value: 'BN', displayValue: 'Brunei Darussalam' },
        { value: 'BG', displayValue: 'Bulgaria' },
        { value: 'BF', displayValue: 'Burkina Faso' },
        { value: 'BI', displayValue: 'Burundi' },
        { value: 'KH', displayValue: 'Cambodia' },
        { value: 'CM', displayValue: 'Cameroon' },
        { value: 'CA', displayValue: 'Canada' },
        { value: 'CV', displayValue: 'Cape Verde' },
        { value: 'KY', displayValue: 'Cayman Islands' },
        { value: 'CF', displayValue: 'Central African Republic' },
        { value: 'TD', displayValue: 'Chad' },
        { value: 'CL', displayValue: 'Chile' },
        { value: 'CN', displayValue: 'China' },
        { value: 'CX', displayValue: 'Christmas Island' },
        { value: 'CC', displayValue: 'Cocos (Keeling) Islands' },
        { value: 'CO', displayValue: 'Colombia' },
        { value: 'KM', displayValue: 'Comoros' },
        { value: 'CG', displayValue: 'Congo' },
        { value: 'CD', displayValue: 'Congo, the Democratic Republic of the' },
        { value: 'CK', displayValue: 'Cook Islands' },
        { value: 'CR', displayValue: 'Costa Rica' },
        { value: 'CI', displayValue: 'Côte d\'Ivoire' },
        { value: 'HR', displayValue: 'Croatia' },
        { value: 'CU', displayValue: 'Cuba' },
        { value: 'CW', displayValue: 'Curaçao' },
        { value: 'CY', displayValue: 'Cyprus' },
        { value: 'CZ', displayValue: 'Czech Republic' },
        { value: 'DK', displayValue: 'Denmark' },
        { value: 'DJ', displayValue: 'Djibouti' },
        { value: 'DM', displayValue: 'Dominica' },
        { value: 'DO', displayValue: 'Dominican Republic' },
        { value: 'EC', displayValue: 'Ecuador' },
        { value: 'EG', displayValue: 'Egypt' },
        { value: 'SV', displayValue: 'El Salvador' },
        { value: 'GQ', displayValue: 'Equatorial Guinea' },
        { value: 'ER', displayValue: 'Eritrea' },
        { value: 'EE', displayValue: 'Estonia' },
        { value: 'ET', displayValue: 'Ethiopia' },
        { value: 'FK', displayValue: 'Falkland Islands (Malvinas)' },
        { value: 'FO', displayValue: 'Faroe Islands' },
        { value: 'FJ', displayValue: 'Fiji' },
        { value: 'FI', displayValue: 'Finland' },
        { value: 'GF', displayValue: 'French Guiana' },
        { value: 'PF', displayValue: 'French Polynesia' },
        { value: 'TF', displayValue: 'French Southern Territories' },
        { value: 'GA', displayValue: 'Gabon' },
        { value: 'GM', displayValue: 'Gambia' },
        { value: 'GE', displayValue: 'Georgia' },
        { value: 'GH', displayValue: 'Ghana' },
        { value: 'GI', displayValue: 'Gibraltar' },
        { value: 'GR', displayValue: 'Greece' },
        { value: 'GL', displayValue: 'Greenland' },
        { value: 'GD', displayValue: 'Grenada' },
        { value: 'GP', displayValue: 'Guadeloupe' },
        { value: 'GU', displayValue: 'Guam' },
        { value: 'GT', displayValue: 'Guatemala' },
        { value: 'GG', displayValue: 'Guernsey' },
        { value: 'GN', displayValue: 'Guinea' },
        { value: 'GW', displayValue: 'Guinea-Bissau' },
        { value: 'GY', displayValue: 'Guyana' },
        { value: 'HT', displayValue: 'Haiti' },
        { value: 'HM', displayValue: 'Heard Island and McDonald Islands' },
        { value: 'VA', displayValue: 'Holy See (Vatican City State)' },
        { value: 'HN', displayValue: 'Honduras' },
        { value: 'HK', displayValue: 'Hong Kong' },
        { value: 'HU', displayValue: 'Hungary' },
        { value: 'IS', displayValue: 'Iceland' },
        { value: 'IN', displayValue: 'India' },
        { value: 'ID', displayValue: 'Indonesia' },
        { value: 'IR', displayValue: 'Iran, Islamic Republic of' },
        { value: 'IQ', displayValue: 'Iraq' },
        { value: 'IE', displayValue: 'Ireland' },
        { value: 'IM', displayValue: 'Isle of Man' },
        { value: 'IL', displayValue: 'Israel' },
        { value: 'JM', displayValue: 'Jamaica' },
        { value: 'JP', displayValue: 'Japan' },
        { value: 'JE', displayValue: 'Jersey' },
        { value: 'JO', displayValue: 'Jordan' },
        { value: 'KZ', displayValue: 'Kazakhstan' },
        { value: 'KE', displayValue: 'Kenya' },
        { value: 'KI', displayValue: 'Kiribati' },
        { value: 'KP', displayValue: 'Korea, Democratic People\'s Republic of' },
        { value: 'KR', displayValue: 'Korea, Republic of' },
        { value: 'KW', displayValue: 'Kuwait' },
        { value: 'KG', displayValue: 'Kyrgyzstan' },
        { value: 'LA', displayValue: 'Lao People\'s Democratic Republic' },
        { value: 'LV', displayValue: 'Latvia' },
        { value: 'LB', displayValue: 'Lebanon' },
        { value: 'LS', displayValue: 'Lesotho' },
        { value: 'LR', displayValue: 'Liberia' },
        { value: 'LY', displayValue: 'Libya' },
        { value: 'LI', displayValue: 'Liechtenstein' },
        { value: 'LT', displayValue: 'Lithuania' },
        { value: 'LU', displayValue: 'Luxembourg' },
        { value: 'MO', displayValue: 'Macao' },
        { value: 'MK', displayValue: 'Macedonia, the former Yugoslav Republic of' },
        { value: 'MG', displayValue: 'Madagascar' },
        { value: 'MW', displayValue: 'Malawi' },
        { value: 'MY', displayValue: 'Malaysia' },
        { value: 'MV', displayValue: 'Maldives' },
        { value: 'ML', displayValue: 'Mali' },
        { value: 'MT', displayValue: 'Malta' },
        { value: 'MH', displayValue: 'Marshall Islands' },
        { value: 'MQ', displayValue: 'Martinique' },
        { value: 'MR', displayValue: 'Mauritania' },
        { value: 'MU', displayValue: 'Mauritius' },
        { value: 'YT', displayValue: 'Mayotte' },
        { value: 'MX', displayValue: 'Mexico' },
        { value: 'FM', displayValue: 'Micronesia, Federated States of' },
        { value: 'MD', displayValue: 'Moldova, Republic of' },
        { value: 'MC', displayValue: 'Monaco' },
        { value: 'MN', displayValue: 'Mongolia' },
        { value: 'ME', displayValue: 'Montenegro' },
        { value: 'MS', displayValue: 'Montserrat' },
        { value: 'MA', displayValue: 'Morocco' },
        { value: 'MZ', displayValue: 'Mozambique' },
        { value: 'MM', displayValue: 'Myanmar' },
        { value: 'NA', displayValue: 'Namibia' },
        { value: 'NR', displayValue: 'Nauru' },
        { value: 'NP', displayValue: 'Nepal' },
        { value: 'NL', displayValue: 'Netherlands' },
        { value: 'NC', displayValue: 'New Caledonia' },
        { value: 'NZ', displayValue: 'New Zealand' },
        { value: 'NI', displayValue: 'Nicaragua' },
        { value: 'NE', displayValue: 'Niger' },
        { value: 'NG', displayValue: 'Nigeria' },
        { value: 'NU', displayValue: 'Niue' },
        { value: 'NF', displayValue: 'Norfolk Island' },
        { value: 'MP', displayValue: 'Northern Mariana Islands' },
        { value: 'NO', displayValue: 'Norway' },
        { value: 'OM', displayValue: 'Oman' },
        { value: 'PK', displayValue: 'Pakistan' },
        { value: 'PW', displayValue: 'Palau' },
        { value: 'PS', displayValue: 'Palestinian Territory, Occupied' },
        { value: 'PA', displayValue: 'Panama' },
        { value: 'PG', displayValue: 'Papua New Guinea' },
        { value: 'PY', displayValue: 'Paraguay' },
        { value: 'PE', displayValue: 'Peru' },
        { value: 'PH', displayValue: 'Philippines' },
        { value: 'PN', displayValue: 'Pitcairn' },
        { value: 'PL', displayValue: 'Poland' },
        { value: 'PR', displayValue: 'Puerto Rico' },
        { value: 'QA', displayValue: 'Qatar' },
        { value: 'RE', displayValue: 'Réunion' },
        { value: 'RO', displayValue: 'Romania' },
        { value: 'RU', displayValue: 'Russian Federation' },
        { value: 'RW', displayValue: 'Rwanda' },
        { value: 'BL', displayValue: 'Saint Barthélemy' },
        { value: 'SH', displayValue: 'Saint Helena, Ascension and Tristan da Cunha' },
        { value: 'KN', displayValue: 'Saint Kitts and Nevis' },
        { value: 'LC', displayValue: 'Saint Lucia' },
        { value: 'MF', displayValue: 'Saint Martin (French part)' },
        { value: 'PM', displayValue: 'Saint Pierre and Miquelon' },
        { value: 'VC', displayValue: 'Saint Vincent and the Grenadines' },
        { value: 'WS', displayValue: 'Samoa' },
        { value: 'SM', displayValue: 'San Marino' },
        { value: 'ST', displayValue: 'Sao Tome and Principe' },
        { value: 'SA', displayValue: 'Saudi Arabia' },
        { value: 'SN', displayValue: 'Senegal' },
        { value: 'RS', displayValue: 'Serbia' },
        { value: 'SC', displayValue: 'Seychelles' },
        { value: 'SL', displayValue: 'Sierra Leone' },
        { value: 'SG', displayValue: 'Singapore' },
        { value: 'SX', displayValue: 'Sint Maarten (Dutch part)' },
        { value: 'SK', displayValue: 'Slovakia' },
        { value: 'SI', displayValue: 'Slovenia' },
        { value: 'SB', displayValue: 'Solomon Islands' },
        { value: 'SO', displayValue: 'Somalia' },
        { value: 'ZA', displayValue: 'South Africa' },
        { value: 'GS', displayValue: 'South Georgia and the South Sandwich Islands' },
        { value: 'SS', displayValue: 'South Sudan' },
        { value: 'LK', displayValue: 'Sri Lanka' },
        { value: 'SD', displayValue: 'Sudan' },
        { value: 'SR', displayValue: 'Suriname' },
        { value: 'SJ', displayValue: 'Svalbard and Jan Mayen' },
        { value: 'SZ', displayValue: 'Swaziland' },
        { value: 'SE', displayValue: 'Sweden' },
        { value: 'CH', displayValue: 'Switzerland' },
        { value: 'SY', displayValue: 'Syrian Arab Republic' },
        { value: 'TW', displayValue: 'Taiwan, Province of China' },
        { value: 'TJ', displayValue: 'Tajikistan' },
        { value: 'TZ', displayValue: 'Tanzania, United Republic of' },
        { value: 'TH', displayValue: 'Thailand' },
        { value: 'TL', displayValue: 'Timor-Leste' },
        { value: 'TG', displayValue: 'Togo' },
        { value: 'TK', displayValue: 'Tokelau' },
        { value: 'TO', displayValue: 'Tonga' },
        { value: 'TT', displayValue: 'Trinidad and Tobago' },
        { value: 'TN', displayValue: 'Tunisia' },
        { value: 'TR', displayValue: 'Turkey' },
        { value: 'TM', displayValue: 'Turkmenistan' },
        { value: 'TC', displayValue: 'Turks and Caicos Islands' },
        { value: 'TV', displayValue: 'Tuvalu' },
        { value: 'UG', displayValue: 'Uganda' },
        { value: 'UA', displayValue: 'Ukraine' },
        { value: 'AE', displayValue: 'United Arab Emirates' },
        { value: 'UM', displayValue: 'United States Minor Outlying Islands' },
        { value: 'UY', displayValue: 'Uruguay' },
        { value: 'UZ', displayValue: 'Uzbekistan' },
        { value: 'VU', displayValue: 'Vanuatu' },
        { value: 'VE', displayValue: 'Venezuela, Bolivarian Republic of' },
        { value: 'VN', displayValue: 'Viet Nam' },
        { value: 'VG', displayValue: 'Virgin Islands, British' },
        { value: 'VI', displayValue: 'Virgin Islands, U.S.' },
        { value: 'WF', displayValue: 'Wallis and Futuna' },
        { value: 'EH', displayValue: 'Western Sahara' },
        { value: 'YE', displayValue: 'Yemen' },
        { value: 'ZM', displayValue: 'Zambia' },
        { value: 'ZW', displayValue: 'Zimbabwe' }
    ];
};

export const getTagToDisplay = (tags = [], singleTag = false) => {
    tags = tags.filter(tag => tag.name.indexOf('lang:') === -1);
    const hasOtherTags = tags.some(tag => tag.name !== 'AIDA');

    if (singleTag && hasOtherTags) {
        return [ tags.filter(tag => tag.name !== 'AIDA')[ 0 ] ];
    }
    else {
        return tags;
    }
};

